/** 已发布地图图层树数据（名称用创建任务时的 name，不追加间距后缀） */
export function buildMapKindTreeData(kind, mapPublishedLayers) {
  const list = (mapPublishedLayers || []).filter((ly) => ly.kind === kind);
  const children = list.map((ly) => ({
    key: String(ly.id),
    title: `${ly.name || `图层 #${ly.id}`}${ly.dryRun ? '（试跑）' : ''}`,
    layerId: ly.id,
    disableCheckbox: !!ly.dryRun || ly.overlayable === false,
    isLeaf: true
  }));
  return [{
    key: `root-${kind}`,
    title: kind === 'contour' ? '系统等高线' : '系统路网',
    disableCheckbox: true,
    children: children.length
      ? children
      : [{ key: `empty-${kind}`, title: '暂无已发布图层', disableCheckbox: true, isLeaf: true }]
  }];
}
